const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuasar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "file_type_quasar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 14,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.291,16A2.29,2.29,0,0,1,16,18.29h0A2.29,2.29,0,0,1,13.71,16h0a2.29,2.29,0,0,1,4.581,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.168,10.129a11.741,11.741,0,0,0-1.8-2.352L21.721,9.305a8.82,8.82,0,0,0-2.765-1.6,10.866,10.866,0,0,0-2.14,3.053,12.959,12.959,0,0,1,8.818,3.074l1.666-.962a11.741,11.741,0,0,0-1.133-2.739Z",
    style: {
      fill: "#1976d2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.169,21.869a11.741,11.741,0,0,0,1.137-2.734l-2.648-1.529a8.82,8.82,0,0,0,.005-3.2,10.866,10.866,0,0,0-3.714-.327A12.959,12.959,0,0,1,22.7,23.258l1.666.962A11.741,11.741,0,0,0,26.169,21.869Z",
    style: {
      fill: "#42a5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,27.74a11.741,11.741,0,0,0,2.937-.382V24.3a8.819,8.819,0,0,0,2.77-1.593,10.866,10.866,0,0,0-1.574-3.38,12.959,12.959,0,0,1-7.071,6.1v1.924A11.741,11.741,0,0,0,16,27.74Z",
    style: {
      fill: "#1976d2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.834,21.87a11.741,11.741,0,0,0,1.8,2.352l2.648-1.529a8.819,8.819,0,0,0,2.765,1.6,10.866,10.866,0,0,0,2.14-3.053,12.959,12.959,0,0,1-8.818-3.074L4.7,19.131A11.741,11.741,0,0,0,5.834,21.87Z",
    style: {
      fill: "#42a5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.833,10.13A11.741,11.741,0,0,0,4.7,12.864l2.648,1.529a8.819,8.819,0,0,0-.005,3.2,10.866,10.866,0,0,0,3.714.327A12.959,12.959,0,0,1,9.305,8.741L7.639,7.779A11.741,11.741,0,0,0,5.833,10.13Z",
    style: {
      fill: "#1976d2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,4.259a11.741,11.741,0,0,0-2.937.382V7.7a8.819,8.819,0,0,0-2.77,1.593,10.866,10.866,0,0,0,1.574,3.38,12.959,12.959,0,0,1,7.071-6.1V4.648A11.741,11.741,0,0,0,16,4.259Z",
    style: {
      fill: "#42a5f5"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuasar);
export default __webpack_public_path__ + "static/media/quasar.46efbd07e096f2d36f13c6f9f8bd161f.svg";
export { ForwardRef as ReactComponent };